<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
  <path d="M5.593 9.677a.497.497 0 0 0 0 .707.508.508 0 0 0 .714 0L8 8.707l1.693 1.677a.508.508 0 0 0 .714 0 .497.497 0 0 0 0-.707L8.714 8l1.693-1.677a.497.497 0 0 0 0-.707.508.508 0 0 0-.714 0L8 7.293 6.307 5.616a.508.508 0 0 0-.714 0 .497.497 0 0 0 0 .707L7.286 8 5.593 9.677Z"/>
  <path d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 0 2 8a6 6 0 0 0 12 0Z"/>
</svg>
